var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 8,
    viewBox: "0 0 167 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.354 4.35355C166.549 4.15829 166.549 3.84171 166.354 3.64645L163.172 0.464466C162.976 0.269204 162.66 0.269204 162.464 0.464466C162.269 0.659728 162.269 0.976311 162.464 1.17157L165.293 4L162.464 6.82843C162.269 7.02369 162.269 7.34027 162.464 7.53553C162.66 7.7308 162.976 7.7308 163.172 7.53553L166.354 4.35355ZM0 4.5H166V3.5H0V4.5Z",
    fill: "#003366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.fe716d8034fdd897e52fdcef12a3b1bb.svg";
export { ForwardRef as ReactComponent };